import slugify from "../../../plugins/slugify";

export default function (context) {
    const $context = $(context);
    const $chosenCategory = $context.find('.object-choose-radio:checked');
    const $setVariableValuesByNamesSwitch = $context.find('.setVariableValuesByNames');
    const isCategoryLotto = $chosenCategory.is('#category-stimuli-flex');

    $setVariableValuesByNamesSwitch.closest('.lotto-part-option').toggleClass('hide', !isCategoryLotto);

    $setVariableValuesByNamesSwitch
        .unbind('change')
        .on('change', function (e) {
            const isChecked = $(this).is(':checked');
            $context.find('.list-objects .survey-item').each(function (index, object) {
                let stimuliName = $(object).find('[data-stimuli-name]').val();
                let $variableValueInput = $(object).find('[data-stimuli-variable-value]');

                $variableValueInput.val(isChecked ? slugify(stimuliName) : $variableValueInput.attr('data-variable-value-number'));
            });
        });
}
